import api from './api';

export const getDepartments = (params) => api.get('/v1/departments', { params });
export const getDepartment = (id) => api.get(`/v1/departments/${id}`);
export const createDepartment = (data) => api.post('/v1/departments', data);
export const updateDepartment = (id, data) => api.put(`/v1/departments/${id}`, data);
export const deleteDepartment = (id) => api.delete(`/v1/departments/${id}`);
export const batchDeleteDepartments = (ids) => api.post('/v1/departments/batch-delete', { ids });
